import React  from 'react';  

export const dashboardConfig = [
 
  {
    auth: ['user'],
    routes: [
      {
        path: '/dashboard',
        component: React.lazy(() => import('./AppDashboard')),
      },
    ],
  },
 
];

